// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1yZ_f","title":"ClientInsurance_title__Nq3Um","itemText":"ClientInsurance_itemText__32XEy"};